import React from 'react'

import { useUserAPI } from '../../../../../providers/UserAPIProvider'

import NamedAvatar from '../../../../../components/atoms/NamedAvatar'
import useStyles from './styles'

const AssociatedUser = ({ userId }) => {
  const { allUsers, loadUser } = useUserAPI()
  const isLoaded = !!allUsers[userId]
  const user = allUsers[userId]
  const noUser = !userId
  const classes = useStyles({ noUser: noUser })

  React.useEffect(() => {
    if (!allUsers[userId]) {
      loadUser(userId)
    }
  }, [allUsers, loadUser, userId])

  if (!userId) return <div className={classes.noUser}>No user</div>

  return (
    <div className={classes.root}>
      {!isLoaded ? (
        'Loading...'
      ) : (
        <NamedAvatar user={user} avatarClassName={classes.avatar} />
      )}
    </div>
  )
}

export default AssociatedUser
